import MobileLocale from './MobileLocale'
export default MobileLocale
